<template>
    <v-card :height="height" :width="width" :outlined="outlined" :elevation="elevation">
        <v-card-title v-if="showTitle" class="d-flex justify-space-between">
            <span>{{ title }}</span>
            <v-btn v-if="WOWKIT_MAKER || isSuperAdmin" class="mr-2" small dense :color="btnColor"
                :to="to"
                :title="btnText"
                @click="openDialog">
                <v-icon left small>{{ icon }}</v-icon> {{ btnText }}
            </v-btn>
        </v-card-title>
        <v-card-text>
            <slot></slot>
        </v-card-text>
    </v-card>
</template>
<script>
export default {
  name: 'WowKitCardComponent',
  props: {
    screenType: {
      dafault: '',
      type: String
    },
    showTitle: {
      default: true,
      type: Boolean
    },
    title: {
      default: 'Card Title',
      type: String
    },
    btnText: {
      default: 'Button',
      type: String
    },
    icon: {
      default: 'mdi-plus',
      type: String
    },
    to: {
      default: () => {},
      type: Object
    },
    outlined: {
      default: false,
      type: Boolean
    },
    elevation: {
      type: [Array, String],
      default: null
    },
    width: {
      type: [Number, String],
      default: null
    },
    WOWKIT_MAKER: {
      type: Boolean,
      default: false
    },
    btnColor: {
      type: String,
      default: 'accent'
    },
    height: {
      default: '',
      type: [Number, String]
    },
    isSuperAdmin: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    openDialog: function () {
      this.$emit('click', true)
    }
  }
}
</script>
